import { useEffect, useMemo, useState } from 'react'
import { SPECIAL_THEMES } from '../lib/themesConfig'

export default function ThemeDecor() {
  const [theme, setTheme] = useState(() => document.documentElement.getAttribute('data-theme'))

  useEffect(() => {
    const obs = new MutationObserver(() =>
      setTheme(document.documentElement.getAttribute('data-theme'))
    )
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] })
    return () => obs.disconnect()
  }, [])

  const decor = SPECIAL_THEMES[theme]?.decor

  const particles = useMemo(() => {
    if (!decor) return []
    const isBounce = decor.motion === 'bounce'
    return Array.from({ length: decor.count }, (_, i) => ({
      id: i,
      emoji: decor.emojis[i % decor.emojis.length],
      left: Math.round((i + Math.random() * 0.8) * (100 / decor.count)),
      top: Math.round(Math.random() * 90),
      size: isBounce ? 26 + Math.round(Math.random() * 14) : 14 + Math.round(Math.random() * 14),
      duration: isBounce ? 14 + Math.random() * 10 : 9 + Math.random() * 9,
      delay: -Math.random() * 18,
      drift: isBounce ? 40 + Math.round(Math.random() * 100) : Math.round(Math.random() * 60 - 30),
      bounce: 1.4 + Math.random() * 1.2,          // segundos por rebote
      height: 140 + Math.round(Math.random() * 220), // altura del rebote en px
    }))
  }, [decor])

  if (!decor) return null

  return (
    <div
      aria-hidden="true"
      style={{ position: 'fixed', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 5 }}
    >
      {particles.map(p =>
        decor.motion === 'bounce' ? (
          <span
            key={p.id}
            className="theme-particle theme-particle--roll"
            style={{
              left: `${p.left}%`,
              animationDuration: `${p.duration}s`,
              animationDelay: `${p.delay}s`,
              '--drift': `${p.drift}px`,
            }}
          >
            <span
              className="theme-ball"
              style={{
                fontSize: p.size,
                animationDuration: `${p.bounce}s`,
                animationDelay: `${p.delay}s`,
                '--h': `${p.height}px`,
              }}
            >
              {p.emoji}
            </span>
          </span>
        ) : (
          <span
            key={p.id}
            className={`theme-particle theme-particle--${decor.motion}`}
            style={{
              left: `${p.left}%`,
              top: decor.motion === 'sway' ? `${p.top}%` : undefined,
              fontSize: p.size,
              animationDuration: `${p.duration}s`,
              animationDelay: `${p.delay}s`,
              '--drift': `${p.drift}px`,
            }}
          >
            {p.emoji}
          </span>
        )
      )}
    </div>
  )
}